















import ChooseGroupLayout from './ChooseGroupLayout.vue';
import ChooseGroupItem from './ChooseGroupItem.vue';
import Filter from '@/models/filter.model';
import FilterGroup from '@/models/filter-group.model';
import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi';

export default {
    name: 'ChooseGroup',
    components: {
        ChooseGroupLayout,
        ChooseGroupItem,
    },
    props: {
        filterGroup: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleFilterChange(e: Event, filterGroup: FilterGroup, filter: Filter) {
            const filterGroupFilterCombi = new FilterGroupFilterCombi(filterGroup, filter)

            if (this.$store.getters.isSelectedFilter(filter)) {
                this.$store.dispatch('unselectFilter', filterGroupFilterCombi);
            } else {
                this.$store.dispatch('selectFilter', filterGroupFilterCombi);
            }
        },
    },
    mounted() {
        // this.initTooltips();
    },
};
